import { RenderRequest } from '../../types';
import { api } from './base';

export const renderApi = {
  render: async (request: RenderRequest) => {
    const response = await api.post('/render', request);
    return response.data.data;
  },

  renderBatch: async (projectId: string, documents: string[], answers: Record<string, unknown>, format?: 'html' | 'pdf') => {
    const response = await api.post('/render/batch', {
      projectId,
      documents,
      answers,
      format
    });
    return response.data.data;
  },

  preview: async (sourcePath: string, answers: Record<string, unknown>) => {
    const response = await api.post('/render/preview', { sourcePath, answers }, {
      responseType: 'text'
    });
    return response.data as string;
  }
};

export const validationApi = {
  validateMetadata: async (projectId: string) => {
    const response = await api.post('/validation', { projectId, checks: ['metadata'] });
    return response.data.data;
  },

  validateLinks: async (projectId: string) => {
    const response = await api.post('/validation', { projectId, checks: ['links'] });
    return response.data.data;
  },

  validateCrosswalk: async (projectId: string) => {
    const response = await api.post('/validation', { projectId, checks: ['crosswalk'] });
    return response.data.data;
  },

  validateAll: async (projectId: string) => {
    const response = await api.post('/validation', { projectId, checks: ['metadata', 'documents', 'links'] });
    return response.data.data;
  }
};

export const crosswalkApi = {
  get: async (std?: string, clause?: string) => {
    const params: Record<string, string> = {};
    if (std) params.std = std;
    if (clause) params.clause = clause;
    
    const response = await api.get('/crosswalk', { params });
    return response.data.data;
  },

  // Get crosswalk entries/mappings - used by usePanelData
  getEntries: async (std?: string, clause?: string) => {
    const params: Record<string, string> = {};
    if (std) params.std = std;
    if (clause) params.clause = clause;
    
    const response = await api.get('/crosswalk', { params });
    // Backend returns { mappings, standards, totalMappings, version }
    return response.data.data.mappings || [];
  },

  // Get list of available standards for filtering
  getStandards: async () => {
    const response = await api.get('/crosswalk/standards');
    return response.data.data;
  },

  getByDocument: async (documentPath: string) => {
    const response = await api.get(`/crosswalk/document/${documentPath}`);
    return response.data.data;
  },

  getByStandard: async (standard: string) => {
    const response = await api.get(`/crosswalk/standard/${standard}`);
    return response.data.data;
  }
};
